import styled from 'styled-components';

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: end;
  padding: 24px 0;
  gap: 8px;
`;

export const NameAndDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .ant-form-item {
    margin-bottom: 0 !important;
  }
`;

export const LockActivityWrapper = styled.div`
  margin-top: 24px;
  display: flex;
  align-items: center;
  gap: 8px;

  .ant-form-item {
    margin-bottom: 0 !important;
  }
`;

export const LockActivityLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

export const ActivityTypeWrapper = styled.div`
  margin-top: 24px;
`;
